var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-header",class:_vm.align},[_c('h1',{staticClass:"banner-header__header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('div',{staticClass:"banner-header__hr"}),_vm._v(" "),_c('div',{staticClass:"banner-header__teaser rich-text",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.teaser))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }